<template>
  <div class="customers">
    <div class="customers-toolbar">
      <label class="h4 font-weight-bolder mr-5">Customers</label>
      <b-form-select class="customers-toolbar-sortby mr-1" v-model="sortby" :options="sortOptions"></b-form-select>
      <b-input-group class="customers-toolbar-search" prepend="search">
        <b-form-input v-model="search"></b-form-input>
      </b-input-group>
    </div>
    <div class="customers-list border-top">
      <customer-card v-for="(c,i) in customers" :key="i+c.name" :dealerno="c.dealer_number">{{c}}</customer-card>
    </div>
  </div>
</template>

<script>
import CustomerCard from "@/components/CustomerCard";
export default {
  components: { CustomerCard },
  data() {
    return {
      selected: "cards",
      sortby: "name",
      search: "",
      sortOptions: [
        { value: "name", text: "Name" },
        { value: "email", text: "Email" },
        { value: "dealer_number", text: "Dealer Number" }
      ]
    };
  },
  computed: {
    customers() {
      let sortby = this.$data.sortby;
      return this.$store.state.customers
        .sort((a, b) => {
          let aClean = a[sortby];
          let bClean = b[sortby];
          if (sortby == "name" || sortby == "email") {
            aClean = aClean.toUpperCase();
            bClean = bClean.toUpperCase();
          }

          if (aClean < bClean) return -1;
          else if (aClean > bClean) return 1;
          else return 0;
        })
        .filter(c => {
          let filterQuery = String(c[sortby]);
          return filterQuery
            .toUpperCase()
            .includes(this.$data.search.toUpperCase());
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.customers {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;

  &-toolbar {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    margin: 1.5em;

    &-sortby {
      width: 12em;
    }

    &-search {
      width: 20em;
    }
  }

  &-list {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    padding-bottom: 10em;
    overflow-y: auto;
  }

  &-list-card {
    margin: 0.5em;
  }
}
</style>
